var $7ec5b3af15ae2324$exports = {};
$7ec5b3af15ae2324$exports = {
    "collapse": `Colapsar`,
    "columnResizer": `Redimensionador de coluna`,
    "drag": `Arrastar`,
    "expand": `Expandir`,
    "loading": `A carregar...`,
    "loadingMore": `A carregar mais...`,
    "resizeColumn": `Redimensionar coluna`,
    "sortAscending": `Ordenar por ordem ascendente`,
    "sortDescending": `Ordenar por ordem decrescente`
};


export {$7ec5b3af15ae2324$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
